import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { FormBuilderModule } from '@rd/form-builder/form-builder.module';
import { IconModule } from '../../components/icon/icon.module';
import { MatDayjsDateModule } from './adapters/dayjs-mat-adapter.module';
import { DatePickerComponent } from './date-picker.component';

@NgModule({
  declarations: [DatePickerComponent],
  imports: [
    CommonModule,
    FormBuilderModule,
    IconModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatDayjsDateModule,
  ],
  providers: [],
  exports: [DatePickerComponent],
})
export class DatePickerModule {}
